module.exports = __webpack_public_path__ + "img/wsd-icon-2@2x.ee23341f.png";